import { Route, Routes, Outlet } from 'react-router-dom'
import { PageTitle } from '_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { FornecedoresListWrapper } from './fornecedores-list/FornecedoresList'

const FornecedoresPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.fornecedores.descricao')}>
                {t('menu.fornecedores')}
              </PageTitle>
              <FornecedoresListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default FornecedoresPage
